/**
 * 微信公众号登录
 * */
import React, { PureComponent } from 'react';
import { withRouter } from '../WithRouterHOC';
import { Modal, message } from 'antd';
import { CloseCircleOutlined } from '@ant-design/icons';
import qs from 'qs';
import { QRCodeCanvas } from 'qrcode.react';
import CryptoJS from 'crypto-js';
import HTTP from '../../script/service';
import {
  _change_phone_modal,
  _get_point,
  _get_user_info,
  _is_new_process,
  _set_uid_token,
} from '../../store/Action';
import Util from '../../script/util';
import store from '../../store/store';

class WeChatLogin extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      url: '', // WeChat 地址
      uniqueCode: null, // dk
    };
  }

  // 展开
  showModal = () => {
    const uniqueCode = this.returnUniqueCode();

    const params = {
      appid: 'wx1d11bc07223220f1',
      redirect_uri: `${this.props.base.rootConfig.mobilePath}/index.html?dk=${uniqueCode}&channelId=DB73EA2619et`,
      response_type: 'code',
      scope: 'snsapi_userinfo',
      state: '123',
    };
    const url = `https://open.weixin.qq.com/connect/oauth2/authorize?${qs.stringify(params)}`;
    this.setState(
      {
        url,
        visible: true,
        uniqueCode,
      },
      () => {
        this.loginStatus();
      }
    );
  };
  // 隐藏
  hideModal = (e, tmp) => {
    e.preventDefault();
    this.props.hide(e, tmp);
    this.setState({ visible: false });
  };

  // 查看登录状态
  loginStatus = () => {
    const { visible, uniqueCode } = this.state;
    const params = { dk: uniqueCode, source: 1 };
    const bdVid = Util.getParameters('bd_vid');
    if (bdVid) {
      // showUrl 上报
      params['showUrl'] = encodeURIComponent(window.location.href);
    }
    HTTP._get_wechat_polling(params).then((res) => {
      if (res) {
        if (res.code === 200) {
          // 授权成功
          _get_point(() => {
            _set_uid_token({
              uid: res.data.uid,
              token: res.data.accessToken,
              register: 1,
              qKey: 'WeChatLogin',
            });
            _get_user_info(
              {
                uid: res.data.uid,
                token: res.data.accessToken,
                qKey: 'WeChatLogin',
              },
              () => {
                if (!!res && !!res.data && !res.data.bindPhone) {
                  _change_phone_modal(true, false);
                  store.dispatch({
                    type: 'set_is_new_user_info',
                    data: { isNewUserInfo: res.data },
                  });
                } else {
                  _is_new_process(res.data);
                }
              }
            );
            this.resetState();
          });
        } else if (res.code === 520) {
          // 等待 继续查询
          if (!!this.timer) {
            clearInterval(this.timer);
            this.timer = null;
          }
          if (visible && uniqueCode) {
            this.timer = setTimeout(this.loginStatus, 2000);
          }
        } else if (res.code !== 500 && res.code !== 503) {
          // 接口调用失败
          this.resetState();
          message.error((res && res.message) || '登录失败');
        } else {
          // 登录失败， 重新登录
          this.resetState();
          message.error((res && res.message) || '登录失败');
        }
      } else {
        message.warning('微信授权失败');
      }
    });
  };

  // 初始state
  resetState = (callback = null) => {
    this.setState(
      {
        visible: false, // 弹窗
        url: '', // WeChat 地址
        uniqueCode: null, // dk
      },
      () => {
        if (callback) {
          callback();
        }
      }
    );

    clearInterval(this.timer);
    this.timer = null;
  };

  // 返回 key
  returnUniqueCode = () => {
    return (
      CryptoJS.MD5(`${window.location.href}${Date.now()}`).toString() +
      '_' +
      Util.getUUID()
    );
  };

  render() {
    const { visible, url } = this.state;
    return (
      <>
        <Modal
          open={visible}
          wrapClassName="transparent-body"
          centered={true}
          closable={false}
          footer={null}
          keyboard={false}
          maskClosable={false}
          width="800px"
        >
          <div className="wechat-login-plan">
            <span className="close" onClick={this.hideModal}>
              <CloseCircleOutlined />
            </span>
            {visible ? (
              <div className="iframe-border">
                <QRCodeCanvas
                  value={url}
                  size={267}
                  bgColor={'#FFF'}
                  fgColor={'#000'}
                />
              </div>
            ) : null}
          </div>
        </Modal>
      </>
    );
  }
}

export default withRouter(WeChatLogin, { withRef: true });
